import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=76078854&"
import script from "./Assessment.vue?vue&type=script&lang=js&"
export * from "./Assessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports